var PaymentConfirmationStrategy = (function (_, $, PromiseUtil, PaymentStrategy) {

	var PaymentConfirmationStrategy = function (attrs) {
		PaymentStrategy.apply(this, arguments);

		_.extend(this, {
			Confirmation: null
		}, attrs);
	};

	PaymentConfirmationStrategy.prototype = _.extend(window.app.jsUtils.createObjectWithProto(PaymentStrategy.prototype), {
		constructor: PaymentConfirmationStrategy,

		afterComplete: function (data) {
			this._setConfirmation(data);
		},

		afterTryComplete: function (data) {
			this._setConfirmation(data);
		},

		_setConfirmation: function (data) {
			this.Confirmation.set({
				invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
				paymentID: data.Value.PaymentID,
				orderInfoResult: data.Value.OrderInfoResult,
				plannedTransactions: data.Value.PlannedTransactions,
                paymentType: data.Value.PaymentType,
				voucher: data.Value.voucher,
				un: data.Value.un,
				addressString: data.Value.AddressString || '',
				addressAdditionalData: data.Value.AddressAdditionalData
			});
		}
	});

	return PaymentConfirmationStrategy;
})(_, $, PromiseUtil, PaymentStrategy);
